/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolScienceIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-science"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M4.85 21.8Q3.17 21.8 2.46 20.3Q1.75 18.8 2.8 17.5L8.35 10.8L8.35 4.9L7.55 4.9Q7 4.9 6.63 4.5Q6.25 4.1 6.25 3.55Q6.25 3 6.63 2.63Q7 2.25 7.55 2.25L16.45 2.25Q17 2.25 17.4 2.63Q17.8 3 17.8 3.55Q17.8 4.13 17.41 4.51Q17.02 4.9 16.45 4.9L15.7 4.9L15.7 10.8L21.2 17.5Q22.25 18.8 21.52 20.3Q20.8 21.8 19.15 21.8Z" fill={color} />
    </svg>
  );
}
